export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'MT',
        name: 'Maltese 47-key',
        normal: "ċ1234567890-=żqwertyuiopġħasdfghjkl;'zxcvbnm,./",
        shift: { 1: '!@€$%^&*()_+', 35: ':"', 44: '<>?' },
        alt: { 0: '`', 3: '£', 13: '\\', 16: 'è', 20: 'ùìò', 24: '[]à' },
        shift_alt: { 0: '~', 13: '|', 24: '{}' }
    })
}
